import React from "react";
import {showNotification} from "../components/Common/notification";

export function getLogo(name) {
    if (name === 'Amazon Web Services') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/AWS_Square_Transparent.png"
    } else if (name === 'New Relic') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/NewRelic_Square_Transparent.png"
    } else if (name === 'Datadog') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/DataDog_Square_Transparent.png"
    } else if (name === 'Elastic') {
        return "https://10xbluejay.s3.amazonaws.com/Elastic_logo.svg"
    } else if (name === 'Google Cloud Platform') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/GCP_Square_Transparent.png"
    } else if (name === 'Microsoft Azure') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/Azure_Square_Transparent.png"
    } else if (name === 'Dynatrace') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/dynatrace-logo.png"
    } else if (name === 'App Dynamics') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/app-dynamics.png"
    } else if (name === 'PagerDuty') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/PagerDuty_Square_Transparent.png"
    } else if (name === 'OpsGenie') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/OpsGenie_Square_Transparent.png"
    } else if (name === 'VictorOps') {
        return "https://10xbluejay.s3.amazonaws.com/VictorOps_logo.svg"
    } else if (name === 'Slack') {
        return "https://10xbluejay.s3.amazonaws.com/Slack_logo.svg"
    } else if (name === 'Email') {
        return "https://prod-temperstack-public-assets.s3.ap-south-1.amazonaws.com/temperstack-logos/temperstack-emblem.png"
    } else if (name === 'Splunk') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/splunk-logo.png"
    } else if (name === 'Oracle Cloud Infrastructure') {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/OCI-logo.png" // change to /oci/square
    } else if(name === "Temperstack") {
        return "https://prod-temperstack-public-assets.s3.ap-south-1.amazonaws.com/temperstack-logos/temperstack-emblem.png"
    }else if(name === "Grafana") {
            return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/grafana-logo.png"
    }else if(name === "Signoz") {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/signoz.png"
    }
}

export function getStateSpecificADLogo(key, is_application_active = true) {
    let logoURL;
    if(is_application_active) {
        switch (key) {
            case 'appdynamics_applications':
                logoURL = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
                break;
            case 'appdynamics_browser_apps':
                logoURL = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/browser.svg";
                break;
            case 'appdynamics_business_transactions':
                logoURL = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction.svg";
                break;
            case 'appdynamics_external_services':
                logoURL = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/external-service-nr.png";
                break;
            case 'appdynamics_database_calls':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/database.svg';
                break
        }
    }
    return logoURL;
}

export function getDynatraceName(resource_name) {
    if(resource_name){
        if(resource_name==='dynatrace_applications'){
            return 'Applications';
    }else if (resource_name==='dynatrace_services'){
            return 'Services';
    }else if (resource_name==='dynatrace_key_user_actions'){
        return 'Key User Actions';
        }
    else if (resource_name==='AGENTLESS_MONITORING'){
        return 'Agentless Monitors';}
    else if (resource_name==='dynatrace_actions'){
        return 'Actions';
        }
    else if (resource_name==='DATABASE_SERVICE'){
        return 'Database Services';
        }
    else if (resource_name==='dynatrace_http_synthetics'){
        return 'HTTP Synthetics';
        }
    else if (resource_name==='dynatrace_browser_synthetics'){
        return 'Browser Synthetics';
        }
    else {
        return 'Services';
        }
    }
}

export function getDynatraceLogo(resource_name, is_application_active = true) {
    let logoUrl = '';
    if (is_application_active) {
        if (resource_name === 'dynatrace_applications') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
        } else if (resource_name === 'dynatrace_services' || resource_name === 'dynatrace_actions') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction.svg";
        } else if (resource_name === 'AGENTLESS_MONITORING') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/browser.svg";
        } else if (resource_name === 'DATABASE_SERVICE') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/database.svg";
        }else if(resource_name === 'dynatrace_key_user_actions'){
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/browser.svg";
        }else if(resource_name === 'dynatrace_http_synthetics'){
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/synthetics.svg";
        }else if(resource_name === 'dynatrace_browser_synthetics'){
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/synthetics.svg";}
    }   else {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
    }
    return logoUrl;
}

export function getStateSpecificAWSLogo(key, state = 'running') {
    let logoURL;
    if (state === 'running' || state === 'available') {
        switch (key) {
            case 'AWS/EKS/Service':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kubernetes_service.png';
                break;
            case 'AWS/EKS/Namespace':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kubernetes_namespace.png';
                break;
            case 'AWS/EC2':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_ec2.svg';
                break;
            case 'AWS/SES':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_ses.svg';
                break;
            case 'AWS/SQS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_sqs.svg';
                break;
            case 'AWS/RDS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_rds.svg';
                break;
            case 'AWS/ElastiCache':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elasticache.svg';
                break;
            case 'AWS/ECS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_eks_cluster.svg';
                break;
            case 'AWS/Kinesis':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kinesis.svg';
                break;
            case 'AWS/Lambda':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_lambda.svg';
                break;
            case 'AWS/ELB':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elb.svg';
                break;
            case 'AWS/ApplicationELB':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elb.svg';
                break;
            case 'AWS/EKS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_eks_cluster.svg';
                break;
            case 'AWS/AutoScaling':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_autoscaling.svg';
                break;
            case 'AWS/DynamoDB':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_dynamo.svg';
                break;
            case 'AWS/CloudFront':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_cloudfront.svg';
                break;
            case 'AWS/ElastiCache/REDIS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elasticache_redis.png';
                break;
            case 'AWS/ElastiCache/MEMCACHE':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elasticache_memcache.png';
                break;
            case 'AWS/ApiGateway':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_api_gateway.svg';
                break;
            case 'AWS/Kafka/Broker':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kafka.png';
                break;
            case 'AWS/Kafka':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kafka.png';
                break;
            case 'AWS/AmazonMQ':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_amazon_mq.jpeg';
                break;
            case 'AWS/AmazonMQ/RabbitMQ':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_amazon_mq.jpeg';
                break;
            case 'AWS/AmazonMQ/ActiveMQ':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_amazon_mq.jpeg';
                break;
            case 'AWS/RDS/Cluster':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_rds.svg';
                break;
            case 'AWS/DMS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_dms.png';
                break;
            case 'AWS/ES':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_opensearch_service.svg';
                break;
            case 'AWS/AppSync':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-appsync.png';
                break;
            case 'AWS/AppSync/DataSource':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-appsync-datasource.png';
                break;
            case 'AWS/AppSync/Resolver':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-appsync-resolver.png';
                break;
            case 'AWS/WAFV2':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-waf-logo-svg-vector.svg';
                break;
            case 'AWS/WAFV2/RuleGroup':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-waf-logo-svg-vector.svg';
                break;
            case 'AWS/WAFV2/ManagedRuleGroup':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-waf-logo-svg-vector.svg';
                break;
            case 'AWS/GuardDuty':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_guardduty.svg';
                break;
            case 'AWS/DocDB':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_documentdb.png';
                break;
            case 'AWS/DocDB/CLUSTER':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_documentdb.png';
                break;
            default:
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_ec2.svg';
                break;
        }
    } else {
        switch (key) {
            case 'AWS/EKS/Service':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kubernetes_service.png';
                break;
            case 'AWS/EC2':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_ec2_gray.svg';
                break;
            case 'AWS/SES':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_ses_gray.svg';
                break;
            case 'AWS/SQS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_sqs_gray.svg';
                break;
            case 'AWS/RDS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_rds_gray.svg';
                break;
            case 'AWS/ElastiCache':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elasticache_gray.svg';
                break;
            case 'AWS/ECS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_eks_cluster_gray.svg';
                break;
            case 'AWS/Kinesis':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kinesis_gray.svg';
                break;
            case 'AWS/Lambda':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_lambda_gray.svg';
                break;
            case 'AWS/ELB':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elb_gray.svg';
                break;
            case 'AWS/ApplicationELB':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elb_gray.svg';
                break;
            case 'AWS/EKS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_eks_cluster_gray.svg';
                break;
            case 'AWS/AutoScaling':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_autoscaling_gray.svg';
                break;
            case 'AWS/DynamoDB':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_dynamo_gray.svg';
                break;
            case 'AWS/CloudFront':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_cloudfront_gray.svg';
                break;
            case 'AWS/ElastiCache/REDIS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elasticache_redis.png';
                break;
            case 'AWS/ElastiCache/MEMCACHE':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elasticache_memcache.png';
                break;
            case 'AWS/ApiGateway':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_api_gateway.svg';
                break;
            case 'AWS/Kafka/Broker':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kafka.png';
                break;
            case 'AWS/Kafka':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kafka.png';
                break;
            case 'AWS/AmazonMQ':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_amazon_mq.jpeg';
                break;
            case 'AWS/AmazonMQ/RabbitMQ':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_amazon_mq.jpeg';
                break;
            case 'AWS/AmazonMQ/ActiveMQ':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_amazon_mq.jpeg';
                break;
            case 'AWS/RDS/Cluster':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_rds_gray.svg';
                break;
            case 'AWS/DMS':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_dms.svg';
                break;
            case 'AWS/ES':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_opensearch_service.svg';
                break;
            case 'AWS/AppSync':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-appsync.png';
                break;
            case 'AWS/AppSync/DataSource':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-appsync-datasource.png';
                break;
            case 'AWS/AppSync/Resolver':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-appsync-resolver.png';
                break;
            case 'AWS/WAFV2':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-waf-logo-svg-vector.svg';
                break;
            case 'AWS/WAFV2/RuleGroup':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-waf-logo-svg-vector.svg';
                break;
            case 'AWS/WAFV2/ManagedRuleGroup':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-waf-logo-svg-vector.svg';
                break;
            case 'AWS/GuardDuty':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_guardduty.svg';
                break;
            default:
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_ec2_gray.svg';
                break;
        }
    }
    return logoURL;
}

export function getStateSpecificNRLogo(resource_name, is_application_active = true) {
    let logoUrl = '';
    if (is_application_active) {
        if (resource_name === 'apm_app') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
        } else if (resource_name === 'apm_kt') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction.svg";
        } else if (resource_name === 'browser') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/browser.svg";
        } else if (resource_name === 'synthetics') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/synthetics.svg";
        } else if (resource_name === 'apm_transaction') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction.svg";
        } else if (resource_name === 'apm_external_services') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/external-service-nr.png";
        } else {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/mobile.svg";
        }
    } else {
        if (resource_name === 'apm_app') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm_gray.svg";
        } else if (resource_name === 'apm_kt') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction_gray.svg";
        } else if (resource_name === 'apm_transaction') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction_gray.svg";
        } else if (resource_name === 'browser') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/browser_gray.svg";
        } else if (resource_name === 'synthetics') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/synthetics_gray.svg";
        } else if (resource_name === 'apm_external_services') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/external-service-nr.png";
        } else {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/mobile_gray.svg";
        }
    }
    return logoUrl;
}

export function getStateSpecificDatadogLogo(resource_name, is_application_active = true) {
    let logoUrl = '';
    if (is_application_active) {
        if (resource_name === 'apm_service') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/datadog-logos/datadog-apm.svg";
        } else if (resource_name === "datadog_synthetics") {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/synthetics.svg";
        } else {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/datadog-logos/datadog-api.svg";
        }
    } else {
        if (resource_name === 'apm_service') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/datadog-logos/datadog-apm.svg";
        } else if (resource_name === "datadog_synthetics") {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/synthetics.svg";
        } else {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/datadog-logos/datadog-api.svg";
        }
    }
    return logoUrl;
}

export function getStateSpecificSplunkLogo(resource_name, is_application_active = true) {
    let logoUrl = '';
    if (is_application_active) {
        if (resource_name === 'splunk_apm_service') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/datadog-logos/datadog-apm.svg";
        } else if (resource_name === "splunk_browser_synthetics" || resource_name === "splunk_api_synthetics" ||
            resource_name === "splunk_http_synthetics" || resource_name === "splunk_port_synthetics") {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/synthetics.svg";
        } else {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/datadog-logos/datadog-api.svg";
        }
    } else {
        if (resource_name === 'splunk_apm_service') {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/datadog-logos/datadog-apm.svg";
        } else if (resource_name === "splunk_browser_synthetics" || resource_name === "splunk_api_synthetics" ||
            resource_name === "splunk_http_synthetics" || resource_name === "splunk_port_synthetics") {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/synthetics.svg";
        } else {
            logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/datadog-logos/datadog-api.svg";
        }
    }
    return logoUrl;
}

export function getStateSpecificGCPLogo(key, state = 'RUNNING') {
    let logoURL;
    if (state === 'RUNNING' || state === 'available' || state === 'RUNNABLE') {
        switch (key) {
            case 'dataflow_pipeline':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
                break;
            case 'dataflow_job':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
                break;
            case 'pubsub_topic':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/pubsub.png';
                break;
            case 'pubsub_subscription':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/pubsub.png';
                break;
            case 'cloud_storage_bucket':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_storage.png';
                break;
            case 'bigtable_cluster':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/bigtable.png';
                break;
            case 'bigtable':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/bigtable.png';
                break;
            case 'kubernetes':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/google_kubernetes_engine.png';
                break;
            case 'kubernetes_node_pool':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/google_kubernetes_engine.png';
                break;
            case 'cloud_run_job':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_run.png';
                break;
            case 'cloud_run_revision':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_run.png';
                break;
            case 'cloud_function':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_functions.png';
                break;
            case 'memcached_instance':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/memorystore.png';
                break;
            case 'gce_instance':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
                break;
            case 'cloudsql_database':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_sql.png';
                break;
            case 'redis_instance':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/memorystore_redis.png';
                break;
            case 'redis.googleapis.com/Cluster':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/memorystore_redis.png';
                break;
            case 'memcache_node':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/memorystore_memcache.png';
                break;
            case 'compute_instance_group':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/gce_instance_group.png';
                break;
            default:
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
                break;
        }
    } else {
        switch (key) {
            case 'dataflow_pipeline':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine_gray.png';
                break;
            case 'dataflow_job':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine_gray.png';
                break;
            case 'pubsub_topic':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/pubsub_gray.png';
                break;
            case 'pubsub_subscription':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/pubsub_gray.png';
                break;
            case 'cloud_storage_bucket':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_storage_gray.png';
                break;
            case 'bigtable_cluster':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/bigtable_gray.png';
                break;
            case 'bigtable':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/bigtable_gray.png';
                break;
            case 'kubernetes':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/google_kubernetes_engine_gray.png';
                break;
            case 'kubernetes_node_pool':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/google_kubernetes_engine_gray.png';
                break;
            case 'cloud_run_job':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_run_gray.png';
                break;
            case 'cloud_function':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_functions_gray.png';
                break;
            case 'memcached_instance':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/memorystore_gray.png';
                break;
            case 'gce_instance':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine_gray.png';
                break;
            case 'cloudsql_database':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_sql_gray.png';
                break;
            case 'redis_instance':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine_gray.png';
                break;
            case 'compute_instance_group':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine_gray.png';
                break;
            default:
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine_gray.png';
                break;
        }
    }
    return logoURL;
}


export function getStateSpecificAzureLogo(key, state) {
    let logoURL;
    if (state === 'Succeeded' || state === 'Running') {
        switch (key) {
            case 'Microsoft.Compute/virtualMachines':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/virtual-machine.svg';
                break;
            case 'Microsoft.Sql/servers/databases':
                logoURL = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/sql-database.svg"
                break;
            case 'Microsoft.Cache/Redis':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/cache-redis.svg'
                break
            case 'Microsoft.DBforPostgreSQL/flexibleServers':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-database-postgresql-server.svg'
                break
            case 'Microsoft.DBforPostgreSQL/serverGroupsv2':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/01848-icon-service-Arc-PostgreSQL+.svg'
                break
            case 'Microsoft.DBforMySQL/flexibleServers':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-database-mysql-server.svg'
                break
            case 'Microsoft.ApiManagement/service':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/api-management-services.svg'
                break
            case 'Microsoft.Cdn/profiles':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/cdn-profiles.svg'
                break
            case 'Microsoft.DocumentDB/mongoClusters':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-cosmos-db.svg'
                break
            case 'Microsoft.Logic/workflows':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/logic-apps.svg'
                break
            case 'Microsoft.Web/sites':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/function-apps.svg'
                break
            case 'Microsoft.Sql/servers/elasticPools':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/sql-elastic-pools.svg'
                break
            case 'Microsoft.ServiceBus/Namespaces':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/service-bus.svg'
                break
            case 'Microsoft.DataMigration/services':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-database-migration-services.svg'
                break
            case 'Microsoft.EventHub/Namespaces':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/event-hubs.svg'
                break
            default:
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/virtual-machine.svg';
                break;
        }
    } else {
        switch (key) {
            case 'Microsoft.Compute/virtualMachines':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/virtual-machine.svg';
                break;
            case 'Microsoft.Sql/servers/databases':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/sql-database.svg'
                break;
            case 'Microsoft.Cache/Redis':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/cache-redis.svg'
                break
            case 'Microsoft.DBforPostgreSQL/flexibleServers':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-database-postgresql-server.svg'
                break
            case 'Microsoft.DBforPostgreSQL/serverGroupsv2':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/01848-icon-service-Arc-PostgreSQL+.svg'
                break
            case 'Microsoft.DBforMySQL/flexibleServers':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-database-mysql-server.svg'
                break
            case 'Microsoft.ApiManagement/service':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/api-management-services.svg'
                break
            case 'Microsoft.Cdn/profiles':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/cdn-profiles.svg'
                break
            case 'Microsoft.DocumentDB/mongoClusters':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-cosmos-db.svg'
                break
            case 'Microsoft.Logic/workflows':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/logic-apps.svg'
                break
            case 'Microsoft.Web/sites':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/function-apps.svg'
                break
            case 'Microsoft.Sql/servers/elasticPools':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/sql-elastic-pools.svg'
                break
            case 'Microsoft.ServiceBus/Namespaces':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/service-bus.svg'
                break
            case 'Microsoft.DataMigration/services':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-database-migration-services.svg'
                break
            case 'Microsoft.EventHub/Namespaces':
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/event-hubs.svg'
                break
            default:
                logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/virtual-machine.svg';
                break;
        }
    }
    return logoURL;
}


export function getAWSLogo(key) {
    let logoURL;
    switch (key) {
        case 'AWS/EC2':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_ec2.svg';
            break;
        case 'AWS/SES':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_ses.svg';
            break;
        case 'AWS/SQS':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_sqs.svg';
            break;
        case 'AWS/RDS':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_rds.svg';
            break;
        case 'AWS/ElastiCache':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elasticache.svg';
            break;
        case 'AWS/ECS':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_eks_cluster.svg';
            break;
        case 'AWS/Kinesis':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_kinesis.svg';
            break;
        case 'AWS/Lambda':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_lambda.svg';
            break;
        case 'AWS/ELB':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elb.svg';
            break;
        case 'AWS/ApplicationELB':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elb.svg';
            break;
        case 'AWS/EKS':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_eks_cluster.svg';
            break;
        case 'AWS/AutoScaling':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_autoscaling.svg';
            break;
        case 'AWS/DynamoDB':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_dynamo.svg';
            break;
        case 'AWS/CloudFront':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_cloudfront.svg';
            break;
        case 'AWS/ElastiCache/REDIS':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elasticache_redis.png';
            break;
        case 'AWS/ElastiCache/MEMCACHE':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_elasticache_memcache.png';
            break;
        case 'AWS/AppSync':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-appsync.png';
            break;
        case 'AWS/WAFV2':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws-waf-logo-svg-vector.svg';
            break;
        default:
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/awslogos/aws_ec2.svg';
            break;
    }
    return logoURL;
}

export function getAppDynamicsLogo(resource_name) {
    let logoUrl = '';
    if (resource_name==='appdynamics_applications') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
    }else if (resource_name === 'appdynamics_browser_apps') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/browser.svg";
    }else if (resource_name === 'appdynamics_business_transactions') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction.svg";
    }else if (resource_name === 'appdynamics_database_calls') {
        logoUrl = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/database.svg'
    }else if(resource_name === 'appdynamics_external_services'){
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/external-service-nr.png";
    }else{
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
    }
    return logoUrl
}

export function getNRLogo(resource_name) {
    let logoUrl = '';
    if (resource_name === 'apm_app') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
    } else if (resource_name === 'apm_kt') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction.svg";
    } else if (resource_name === 'browser') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/browser.svg";
    } else if (resource_name === 'synthetics') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/synthetics.svg";
    } else {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/mobile.svg";
    }
    return logoUrl;
}

export function getGCPLogo(key) {
    let logoURL;
    switch (key) {
        case 'dataflow_pipeline':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
            break;
        case 'dataflow_job':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
            break;
        case 'pubsub_topic':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/pubsub.png';
            break;
        case 'pubsub_subscription':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/pubsub.png';
            break;
        case 'cloud_storage_bucket':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_storage.png';
            break;
        case 'bigtable_cluster':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/bigtable.png';
            break;
        case 'bigtable':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/bigtable.png';
            break;
        case 'kubernetes':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/google_kubernetes_engine.png';
            break;
        case 'kubernetes_node_pool':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/google_kubernetes_engine.png';
            break;
        case 'cloud_run_job':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_run.png';
            break;
        case 'cloud_function':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_functions.png';
            break;
        case 'memcached_instance':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/memorystore.png';
            break;
        case 'gce_instance':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
            break;
        case 'cloudsql_database':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/cloud_sql.png';
            break;
        case 'redis_instance':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
            break;
        case 'compute_instance_group':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
            break;
        default:
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/gcp-logos/compute_engine.png';
            break;
    }
    return logoURL;
}


export function getAzureLogo(key) {
    let logoURL;
    switch (key) {
        case 'Microsoft.Compute/virtualMachines':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/virtual-machine.svg';
            break;
        case 'Microsoft.Sql/servers/databases':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/sql-database.svg'
            break;
        case 'Microsoft.Cache/Redis':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/cache-redis.svg'
            break;
        case 'Microsoft.DBforPostgreSQL/flexibleServers':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-database-postgresql-server.svg'
            break
        case 'Microsoft.DBforPostgreSQL/serverGroupsv2':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/01848-icon-service-Arc-PostgreSQL+.svg'
            break
        case 'Microsoft.DBforMySQL/flexibleServers':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-database-mysql-server.svg'
            break
        case 'Microsoft.ApiManagement/service':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/api-management-services.svg'
            break
        case 'Microsoft.Cdn/profiles':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/cdn-profiles.svg'
            break
        case 'Microsoft.DocumentDB/mongoClusters':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-cosmos-db.svg'
            break
        case 'Microsoft.Logic/workflows':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/logic-apps.svg'
            break
        case 'Microsoft.Web/sites':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/function-apps.svg'
            break
        case 'Microsoft.Sql/servers/elasticPools':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/sql-elastic-pools.svg'
            break
        case 'Microsoft.ServiceBus/Namespaces':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/service-bus.svg'
            break
        case 'Microsoft.DataMigration/services':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/azure-database-migration-services.svg'
            break
        case 'Microsoft.EventHub/Namespaces':
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/event-hubs.svg'
            break
        default:
            logoURL = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/azure_logos/virtual-machine.svg';
            break;
    }
    return logoURL;
}


export function getNRDisplayName(resource_name) {
    if (resource_name === 'apm_app') {
        return 'APM';
    } else if (resource_name === 'apm_kt') {
        return 'Key Transactions';
    } else if (resource_name === 'browser') {
        return 'Browser';
    } else if (resource_name === 'synthetics') {
        return 'Synthetics';
    } else if (resource_name === 'apm_transaction') {
        return 'Transactions';
    } else if (resource_name === 'apm_external_services') {
        return 'External Service';
    } else {
        return 'Mobile';
    }
}

export function getAzureDisplayName(resource_name) {
    if (resource_name === 'Microsoft.Compute/virtualMachines') {
        return 'Virtual Machine';
    } else if(resource_name==='Microsoft.Sql/servers/databases') {
        return 'Sql Database'
    } else if (resource_name==='Microsoft.Cache/Redis') {
        return 'Azure Redis'
    }else if(resource_name==='Microsoft.SignalRService/WebPubSub') {
        return 'Web Pub Sub'
    }else if (resource_name==='Microsoft.Storage/storageAccounts') {
        return 'Storage Accounts'
    } else if (resource_name==='Microsoft.DBforPostgreSQL/serverGroupsv2') {
        return 'PostgresqlDb for  Server Groups V2'
    }else if(resource_name==='Microsoft.DBforPostgreSQL/flexibleServers') {
        return 'PostgresqlDb for Flexible Servers'
    }else if(resource_name==='Microsoft.ApiManagement/service') {
        return 'Api Management'
    }else if(resource_name==='Microsoft.DBforMySQL/flexibleServers') {
        return 'MySQL for Flexible Servers'
    }else if(resource_name==='Microsoft.DocumentDB/mongoClusters'){
        return 'Mongo Clusters'
    }else if(resource_name==='Microsoft.Cdn/profiles'){
        return 'CDN Profiles and Front Door'
    }else if(resource_name==='Microsoft.Logic/workflows') {
        return 'Logic Apps'
    }else if(resource_name==='Microsoft.Web/sites') {
        return 'Function Apps'
    }else if(resource_name==='Microsoft.Sql/servers/elasticPools') {
        return 'Elastic Pools Sql Server'
    }else if(resource_name==='Microsoft.ServiceBus/Namespaces') {
        return 'Service Bus'
    }else if(resource_name==='Microsoft.DataMigration/services') {
        return 'Data Migration Service'
    }else if(resource_name==='Microsoft.EventHub/Namespaces') {
        return 'Event Hubs'
    } else {
        return 'Azure';
    }
}

export function getSplunkName(resource_name){
    if (resource_name === 'splunk_apm_service') {
        return 'APM Service';
    } else if (resource_name === 'splunk_apm_inferred_service') {
        return 'APM Inferred Service';
    } else if (resource_name === 'splunk_apm_endpoint') {
        return 'APM Endpoint';
    } else if (resource_name === 'splunk_browser_synthetics') {
        return 'Browser Synthetics';
    } else if (resource_name === 'splunk_api_synthetics') {
        return 'API Synthetics';
    } else if (resource_name === 'splunk_http_synthetics') {
        return 'HTTP Uptime Synthetics';
    } else if (resource_name === 'splunk_port_synthetics') {
        return 'Port Uptime Synthetics';
    } else {
        return 'Service'
    }
}

export function getAppDynamicsName(resource_name) {
    if (resource_name === 'appdynamics_applications') {
        return 'Application';
    }else if (resource_name === 'appdynamics_browser_apps') {
        return 'Browser Rum';
    }else if (resource_name === 'appdynamics_business_transactions') {
        return 'Business Transactions';
    }else if (resource_name === 'appdynamics_external_services') {
        return 'External Services';
    }else if(resource_name === 'appdynamics_database_calls') {
        return 'Database';
    }else if (resource_name === 'appdynamics_non_key_business_transactions_transactions') {
        return 'Non Key Transactions';
    }else {
        return 'Service'
    }
}

export function getGrafanaName(resource_name) {
    if (resource_name === 'grafana_services') {
        return 'APM';
    }else if (resource_name === 'grafana_business_transactions') {
        return 'Key Transactions';
    }else if (resource_name === 'grafana_external_services') {
        return 'External Services';
    }else if (resource_name === 'grafana_non_key_transactions') {
        return 'Non Key Transactions';
    }else {
        return 'services'
    }
}


export function getDatadogName(resource_name){
    if (resource_name === 'apm_service') {
        return 'APM Service';
    } else if (resource_name === 'service_api_endpoint') {
        return 'API Endpoint'
    } else if (resource_name === 'registered_api_endpoint') {
        return 'Registered API Endpoint'
    } else if (resource_name === 'datadog_synthetics') {
        return 'Synthetics'
    } else if (resource_name === 'datadog_rum') {
        return 'RUM'
    }else {
        return 'Service'
    }

}


export function getAlertHealth(alert_length, missing_alert_length) {
    if (missing_alert_length === 0) {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/status_icons/greendot.svg";
    } else if (missing_alert_length > 0 && alert_length > 0) {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/status_icons/amberdot.svg";
    } else {
        return "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/status_icons/reddot.svg";
    }
}

export function getMissingAlertsDisplay(alert_length, missing_alert_length) {
    if (missing_alert_length === 0) {
        return <div className="text-success">0 missing</div>;
    } else if (missing_alert_length > 0 && alert_length > 0) {
        return <div className="text-warning">{missing_alert_length} missing</div>;
    } else {
        return <div className="text-danger">{missing_alert_length} missing</div>;
    }
}

export function getLocalDateTime(utcDateTime) {
    if (utcDateTime === null) return "";
    return new Date(utcDateTime).toLocaleString();
}

export function getIntegrationLogo(integration_type) {
    let logoUrl = '';
    if (integration_type === 'CloudWatch' || integration_type === 'AWS' ||integration_type === 'Amazon Web Services') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/AWS_Square_Transparent.png";
    } else if (integration_type === 'NewRelic' || integration_type === 'New Relic') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/NewRelic_Square_Transparent.png";
    } else if (integration_type === 'GCP' || integration_type === 'Google Cloud Platform') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/GCP_Square_Transparent.png"
    } else if (integration_type === 'Azure'||integration_type === 'Microsoft Azure' ) {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/Azure_Square_Transparent.png"
    } else if (integration_type === 'Datadog') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/DataDog_Square_Transparent.png"
    } else if (integration_type === 'Coralogix') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/coralogix.png"
    } else if (integration_type === 'Prometheus') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/prometheus.png"
    } else if (integration_type === 'Sentry') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/sentry-logo.png"
    } else if (integration_type === 'Splunk') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/splunk-logo.png"
    } else if (integration_type === 'Pingdom') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/pingdom.png"
    } else if(integration_type === 'AppDynamics'|| integration_type === 'App Dynamics' ) {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/app-dynamics.png"
    }else if (integration_type === 'Dynatrace') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/dynatrace-logo.png"
    } else if (integration_type === 'TemperstackSynthetics') {
        logoUrl = "https://prod-temperstack-public-assets.s3.ap-south-1.amazonaws.com/temperstack-logos/temperstack-emblem.png"
    } else if (integration_type === "Site24x7") {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/site24x7.png"
    } else if (integration_type === "Email") {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/email-integration-logo.png"
    } else if ( integration_type === "GroundCover"){
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/groundcover.png"
    }else if (integration_type === 'OCI'|| integration_type === 'Oracle Cloud Infrastructure') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/OCI-logo.png"
    }else if (integration_type === 'SigNoz'||integration_type ==='Signoz') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/signoz.png"
    }else if (integration_type === 'Grafana') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/grafana-logo.png"
    }else if (integration_type === 'Langsmith') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/langsmith.png"
    }
    else {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/integration-logos/webhook.png"
    }
    return logoUrl;
}

export function getGrafanaLogo(resource_name) {
    let logo_url = ''
    if (resource_name === 'grafana_services') {
        logo_url = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
    }else if (resource_name === 'grafana_business_transactions') {
        logo_url = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction.svg";
    }else if(resource_name === 'grafana_external_services'){
        logo_url = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/external-service-nr.png";
    }else{
        logo_url = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
    }
    return logo_url;
}

export function getSignozLogo(resource_name) {
    let logo_url = ''
    if (resource_name === 'signoz_services') {
        logo_url = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
    }else if (resource_name === 'signoz_business_transactions') {
        logo_url = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/key_transaction.svg";
    }else if(resource_name === 'signoz_external_services'){
        logo_url = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/external-service-nr.png";
    } else if (resource_name === 'signoz_database_instances') {
        logo_url = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/database.svg";
    }else{
        logo_url = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/newrelic-logos/apm.svg";
    }
    return logo_url;
}

export function getSignozName(resource_name) {
    if (resource_name === 'signoz_services') {
        return 'APM';
    }else if (resource_name === 'signoz_business_transactions') {
        return 'Key Transactions';
    }else if (resource_name === 'signoz_external_services') {
        return 'External Services';
    }else if (resource_name === 'signoz_non_key_transactions') {
        return 'Non Key Transactions';
    }else if (resource_name === 'signoz_database_instances') {
        return 'Database';
    }else {
        return 'services'
    }
}

export function getIntegrationOptions() {
    return [
        { value: 'CloudWatch', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('CloudWatch')} alt="" />CloudWatch</div> },
        { value: 'NewRelic', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('NewRelic')} alt="" />NewRelic</div> },
        { value: 'GCP', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('GCP')} alt="" />GCP</div> },
        { value: 'Azure', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Azure')} alt="" />Azure</div> },
        { value: 'Datadog', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Datadog')} alt="" />Datadog</div> },
        { value: 'Coralogix', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Coralogix')} alt="" />Coralogix</div> },
        { value: 'Prometheus', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Prometheus')} alt="" />Prometheus</div> },
        { value: 'Webhook', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Webhook')} alt="" />Webhook</div> },
        { value: 'Sentry', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Sentry')} alt="" />Sentry</div> },
        { value: 'Pingdom', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Pingdom')} alt="" />Pingdom</div> },
        { value: 'AppDynamics', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('AppDynamics')} alt="" />AppDynamics</div> },
        {value: 'Dynatrace', label: <div className="align-items-center" style={{display: 'flex', alignItems: 'center', gap: '8px'}}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Dynatrace')} alt=""/>Dynatrace</div>},
        {value: 'Splunk', label: <div className="align-items-center" style={{display: 'flex', alignItems: 'center', gap: '8px'}}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Splunk')} alt=""/>Splunk</div>},
        {value: 'TemperstackSynthetics', label: <div className="align-items-center" style={{display: 'flex', alignItems: 'center', gap: '8px'}}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('TemperstackSynthetics')} alt=""/>Temperstack Synthetics</div>},
        {value: 'Site24x7', label: <div className="align-items-center" style={{display: 'flex', alignItems: 'center', gap: '8px'}}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Site24x7')} alt=""/>Site24x7</div>},
        { value: 'Email', label: <div className="align-items-center" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Email')} alt="" />Email</div> },
        {value: 'GroundCover', label: <div className="align-items-center" style={{display: 'flex', alignItems: 'center', gap: '8px'}}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('GroundCover')} alt=""/>GroundCover</div>},
        {value: 'OCI', label: <div className="align-items-center" style={{display: 'flex', alignItems: 'center', gap: '8px'}}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('OCI')} alt=""/>OCI</div>},
        {value: 'SigNoz', label: <div className="align-items-center" style={{display: 'flex', alignItems: 'center', gap: '8px'}}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('SigNoz')} alt=""/>SigNoz</div>},
        {value: 'Grafana', label: <div className="align-items-center" style={{display: 'flex', alignItems: 'center', gap: '8px'}}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Grafana')} alt=""/>Grafana</div>},
        {value: 'Langsmith', label: <div className="align-items-center" style={{display: 'flex', alignItems: 'center', gap: '8px'}}><img className="avatar-xs rounded-circle" src={getIntegrationLogo('Langsmith')} alt=""/>LangSmith</div>},

    ];
}

const colorPalette = [
    "#00CED1", "#18A558", "#408EC6", "#50727B", "#54B19D",
    "#735DA5", "#78A083", "#8CC152", "#90AFC5", "#ADC4CE",
    "#B1515E", "#B7B7B7", "#BFCCB5", "#C1A479", "#C5705D",
    "#D09683", "#D3C5E5", "#D5A6C0", "#E19898", "#E84855",
    "#F1EFEF", "#F98866", "#FEC8DA", "#FF69B4", "#FFA133",
    "#FFB429", "#FFC6AC", "#FFD700", "#FFDAB9", "#FAEED1"
];

const assignedColors = new Map();
export function getUserColor(userId) {
    if (!assignedColors.has(userId)) {
        const color = colorPalette[Math.floor(Math.random() * 35)];
        assignedColors.set(userId, color);
    }
    return assignedColors.get(userId);
}


const assignedColorsForOncall = new Map();
export function getUserColorForOncall(userId) {
    if (!assignedColorsForOncall.has(userId)) {
        const color = getUniqueColor();
        assignedColorsForOncall.set(userId, color);
    }
    return assignedColorsForOncall.get(userId);
}
export function clearColorForUser(userId) {
    assignedColorsForOncall.delete(userId)
}
export function clearMap(){
    assignedColorsForOncall.clear()
}

function getUniqueColor(){
    const usedColors = new Set(assignedColorsForOncall.values());
    if (usedColors.size === colorPalette.length) {
        const randomIndex = Math.floor(Math.random() * colorPalette.length);
        return colorPalette[randomIndex];
    }
    const availableColors = colorPalette.filter(color => !usedColors.has(color));
    const randomIndex = Math.floor(Math.random() * availableColors.length);
    return availableColors[randomIndex];
}

// function getUniqueColor() {
//     let colorIndex = 0;
//     while (usedColors.has(colorPalette[colorIndex])) {
//         colorIndex = (colorIndex + 1) % colorPalette.length;
//     }
//     const color = colorPalette[colorIndex];
//     usedColors.add(color);
//     return color;
// }

export function getOciLogo(resource_name) {
    let logoUrl;
    if (resource_name==='oci_compute_instance') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/oci/compute.svg";
    }else if (resource_name === 'oci_compute_instance_pool') {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/oci/compute.svg";
    }else if (['oci_mysql_database','oci_postgres_database', 'oci_autonomous_database', 'oci_oracle_database'].includes(resource_name)) {
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/oci/database.svg";
    }else if (resource_name === 'oci_bastion') {
        logoUrl = 'https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/oci/bastion.svg'
    }else if(resource_name === 'oci_load_balancer' || resource_name === 'oci_backend_set'){
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/oci/load_balancer.svg";
    }else if (resource_name === 'oci_function'){
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/oci/function.svg";
    }else if(resource_name === 'oci_queue'){
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/oci/queue.svg";
    }else{
        logoUrl = "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/oci/compute.svg";
    }
    return logoUrl
}


export function getOciName(resource_name) {
    if (resource_name === 'oci_compute_instance') {
        return 'Compute Instance';
    } else if(resource_name==='oci_compute_instance_pool') {
        return 'Compute Instance Pool'
    } else if (resource_name==='oci_mysql_database') {
        return 'MySQL Database'
    } else if (resource_name==='oci_postgres_database') {
        return 'PostgreSQL Database'
    } else if (resource_name==='oci_autonomous_database') {
        return 'Autonomous Database'
    } else if (resource_name==='oci_oracle_database') {
        return 'Oracle Database'
    } else if(resource_name==='oci_bastion') {
        return 'Bastion'
    } else if(resource_name==='oci_load_balancer') {
        return 'Load Balancer'
    } else if(resource_name==='oci_function') {
        return 'Function'
    } else if(resource_name==='oci_queue') {
        return 'Queue'
    } else if(resource_name==='oci_backend_set'){
        return 'Backend Set'
    } else {
        return 'Service'
    }
}

export function getIntegrationURL(name) {
    let url = '#';
    if (name === 'Amazon Web Services') {
        url = "/cloud-resources";
    } else if (name === 'New Relic') {
        url = "/new-relic-resources";
    } else if (name === 'Datadog') {
        url = "/datadog-resources";
    } else if (name === 'Google Cloud Platform') {
        url = "/gcp-resources";
    } else if (name === 'Microsoft Azure') {
        url = "/azure-resources";
    } else if (name === 'PagerDuty') {
        url = "/pagerduty-services";
    } else if (name === 'OpsGenie') {
        url = "/opsgenie-teams";
    } else if (name === 'Splunk') {
        url = "/splunk-resources";
    }else if (name === 'Email') {
        url = "/temperstack-notifications";
    }else if (name === 'App Dynamics'){
        url = "/appdynamics-resources"
    }else if(name ==='Dynatrace'){
        url = "/dynatrace-resources"
    }else if(name === 'Temperstack'){
        url = "/ping-monitoring"
    }else if (name === 'Oracle Cloud Infrastructure'){
        url = "/oci-resources"
    }else if(name === 'Grafana'){
        url = "/grafana-resources"
    }else if(name === 'Signoz'){
        url = "/signoz-resources"
    }

    return url;
}

export const customStyles = {
    width: '100%',
    zIndex: 9999,
    height:"20px",
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: "4px",
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',// Background color of dropdown options
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      zIndex: 200,
      // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100,
    }),
  };

export const copyToClipboard = (textToCopy) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(textToCopy)
      .then(() => showNotification('success', 'Copied!'))
      .catch(err => console.error('Could not copy text: ', err));
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      showNotification('success', 'Copied!')
    } catch (err) {
      console.error('Could not copy text: ', err);
    }
    document.body.removeChild(textarea);
  }
};

export function convertS3UriToUrl(s3Uri) {
    const uriParts = s3Uri.split("/");
    try {
        let objectKey = uriParts.at(-1);
        if (objectKey === "") {
            objectKey = uriParts.at(-2);
        }
        return `https://${uriParts[2]}.s3.ap-south-1.amazonaws.com/index.html?prefix=${objectKey}/`
    } catch (e){
        return ""
    }
}